import {
  validateNbAxles,
  validateRegistration,
  validateWagonLength,
  validateWagonTare,
  ValidationErrors,
} from '../../../commons/validation/validationUtils';
import { isRequiredFieldNotEmpty } from '../../../commons/redux-form/valueValidator';
import { WagonTemplate } from '../../../commons/model/templates';

const validateOwnerId = (ownerId: number | null): ValidationErrors<'ownerId'> => {
  if (isRequiredFieldNotEmpty(ownerId)) {
    return {};
  }
  return {
    ownerId: 'Détenteur obligatoire',
  };
};

export const validate = (wagonTemplate: WagonTemplate): ValidationErrors<any> => {
  if (!wagonTemplate) {
    return {};
  }
  return {
    ...validateRegistration(wagonTemplate.registration),
    ...validateWagonLength(wagonTemplate.length),
    ...validateWagonTare(wagonTemplate.tare),
    ...validateNbAxles(wagonTemplate.nbAxles),
    ...validateOwnerId(wagonTemplate.ownerId),
  };
};

export const initialFormValuesForNewWagonTemplates: () => Partial<WagonTemplate> = () => ({
  doubleWagon: false,
});

export const getWagonGeneralStatus = ({ inProgressRepairId, inProgressDamageReports }: WagonTemplate): string => {
  if (inProgressRepairId != null) {
    return 'En atelier';
  } else {
    let inProgressLabels = inProgressDamageReports?.flatMap((dr) => dr.labels);
    if (inProgressLabels?.some((label) => ['M', 'K', 'ONE', 'I', 'R_ONE'].includes(label))) {
      // If any active damage report contains at least one of these labels
      return 'Reformé';
    } else {
      // If no active damage reports, or they don't contain these labels
      return 'Opérationnel';
    }
  }
};
